import React, { useEffect, useState } from "react";
import { Card, Col, Divider, Row, Statistic, Table, Switch, Button, Tag, Tooltip, Input, DatePicker, message, Select, Dropdown, Modal } from "antd";
import "./reports.css";
import { makeStyles } from "@mui/styles";
import { CheckOutlined, CloseOutlined, ExportOutlined, InfoCircleOutlined } from "@ant-design/icons";
import Message from "../../Components/common/Message";
import AuthService from "../../Components/auth/AuthService";
import { formatCurrency } from "../../Components/common/CommonFun";
import { netsuite_url } from "../../Components/config";
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, deliveryStatuses, departments, orderStats, returnReasons, returnStatuses, StockChangeReasons } from "../../Components/common/constants";
import moment from "moment";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import dayjs from "dayjs";
import { Grid, Pagination } from "@mui/material";
import { showMessage } from "../../Components/Utils/message";
import TextArea from "antd/es/input/TextArea";

const Auth = new AuthService();

const useStyles = makeStyles((theme) => ({
  dataSheet: {
    padding: "15px",
    background: "white",
    "& .ant-card .ant-card-body": {
      padding: "4px",
      backgroundColor: "rgb(240, 240, 240)",
    },
    "& .ant-statistic .ant-statistic-content": {
      fontSize: "12px",
      fontWeight: "bold",
    },
    "& .ant-statistic .ant-statistic-title": {
      fontSize: "12px",
    },
    "& .example-custom-input": {
      width: "100% !important",
    },
    "& .react-datepicker-wrapper": {
      width: "100% !important",
    },
  },
}));
const AllReturnsNew = () => {
  const classes = useStyles();
   var layoutDispatch = useLoadingDispatch();
   const currentDate = new Date();
   const { Option } = Select;
   const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
   const lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
   const [startDate, setStartDate] = useState(currentDate);
   const [endDate, setEndDate] = useState(currentDate);
   const [selectedStatus, setSelectedStatus] = useState(null);
   const [selectedOrderStatus, setSelectedOrderStatus] = useState(null);
  //  const [orderStatus, setOrderStatus] = useState(null);
   const [loadMessage, setLoadMessage] = useState("");
   const [type, setType] = useState("");
   const [returns, setReturns] = useState([]); 

    const [page, setPage] = React.useState(1);
     const [pageChange, setPageChange] = React.useState(false);
     const [limit] = React.useState(50);
     const [totalPages, setTotalPages] = React.useState(0);
     const [totalCount, setTotalCount] = React.useState(null);

     const [searchInput, setSearchInput] = useState({
      searchText: ""
    });
    const [returnUpdate, setReturnUpdate] = useState({
      status: null,
      department: null,
      reason: null,
      notes: ''
    });
     const [selectedItem, setSelectedItem] = useState(null);
     const [modalOpen, setModalOpen] = useState(false);
   
 
 
   const getAllReturns = async (download) => {
     let search = {};
     if (!startDate) return;
     if (!endDate) return;
     if (startDate) search.start_date = dayjs(startDate).format(DEFAULT_DATE_FORMAT);
     if (endDate) search.end_date = dayjs(endDate).format(DEFAULT_DATE_FORMAT);
     if (selectedStatus) search.delivery_status = selectedStatus;
     if (selectedOrderStatus) search.order_status = selectedStatus === 3 ? 0 : selectedStatus;
    //  if (orderStatus) {
    //   search.order_status = orderStatus === 3 ? 0 : orderStatus;
    // }
     if (page && pageChange) search.page = page;
     if (searchInput?.searchText) search.searchText = searchInput?.searchText;


    if (download) search.download = 1;


 
     showLoading(layoutDispatch);
     try {
     const res = await Auth.fetch("/route/load-route-returns", {
         method: "POST",
         body: JSON.stringify(search),
       });
       if (res?.ack) {
        if (download == 1) {
            window.open(res.file_url, "_blank", "noreferrer");
          } else {
         setReturns(res?.daily_returns)
         setTotalPages(Math.ceil(res?.total_count / limit));
         setTotalCount(res.total_count);
          }
       } else {
         setReturns([])
         message.error(res?.message)
       }
     } catch (err){
         console.log(err);
         message.error(err?.message)
     } finally {
         hideLoading(layoutDispatch);
     }
   };
 
   useEffect(() => {
     const timeOutId = setTimeout(() => getAllReturns(), 1000);
     return () => clearTimeout(timeOutId);
   }, [
     startDate,
     endDate,
     selectedStatus,
     page
   ]);

   const handleChange = (event, value) => {
    setPage(value);
    setPageChange(true)
  };
 
   const detailsCol = [
     
    {
      title: 'Date',
      render: (record)=> {
        return (
          <>
          <span>{dayjs(record.delivery_date).format(DATE_FORMAT)}</span>
        </>
        )
      },
      // width: 150,

    },
        {
       title: "Route",
       dataIndex: "route",
       key: "route",
      //  width: 80,
     },
     {
       title: "Driver",
       dataIndex: "driver",
       key: "driver",
      //  width: 120,
     },
     {
       title: "Vehicle",
       dataIndex: "vehicle",
       key: "vehicle",
      //  width: 80,
     },
     {
       title: "Customer",
       align: 'center',
       render(record) {
         return (
           <span><a href={`${netsuite_url}/app/common/entity/custjob.nl?id=${record.customer_internal_id}`} target="_blank">{record.customer_name}</a></span>
         );
       },
      //  width: 90,
     },
     {
       title: "Invoice",
       render(record) {
         return (
           <span>
                 <a 
                   href={`${netsuite_url}/app/accounting/transactions/custinvc.nl?id=${record?.inv_internal_id}`} 
                   target="_blank" 
                   rel="noopener noreferrer"
               >
                   {record?.invoice_no}
               </a>
             </span>
         );
       },
      //  width: 90,
     },
     {
       title: "Order",
       render(record) {
         return (
           <span>
                 <a 
                   href={`${netsuite_url}/app/accounting/transactions/salesord.nl?id=${record?.internal_id}`} 
                   target="_blank" 
                   rel="noopener noreferrer"
               >
                   {record?.sale_order_no}
               </a>
             </span>
         );
       },
      //  width: 90,
     },
     {
       title: "Order Status",
      //  filters: [
      //   { text: "Delivered", value: 1 },
      //   { text: "Postponed", value: 2 },
      //   { text: "Submitted", value: -1 },
      //   { text: "Not Delivered", value: 0 }, // default/fallback
      // ],
      // onFilter: (value, record) => {
      //   if (value === 0) {
      //     // treat everything not 1, 2, -1 as Not Delivered
      //     return ![1, 2, -1].includes(record?.delivered);
      //   }
      //   return record?.delivered === value;
      // },
       render(record) {
         let statusText;
         let backgroundColor;
         // let delivered_at = record?.delivered_at || "N/A";
 
         const delivered_at = record?.delivered_at && dayjs(record.delivered_at).isValid()
       ? dayjs(record.delivered_at).format(`${DATE_FORMAT} HH:mm:ss`)
       : "N/A";
 
 
         switch (record?.delivered) {
           case 1:
             statusText = "Delivered";
             backgroundColor = "#80cb80";
             break;
           case 2:
             statusText = "Postponed";
             backgroundColor = "#f0d787";
             break;
             case -1:
             statusText = "Submitted";
             backgroundColor = "#1890FF";
             break;
           default:
             statusText = "Not Delivered";
             backgroundColor = "#f94058ff";
             break;
         }
 
         return {
           props: {
             style: {
               background: backgroundColor,
               textAlign: 'center',
              //  width: "300px",
 
 
             },
           },
           children: (
             <>
             {statusText}
             {record?.delivered === 1 && (
               <Tooltip title={`Delivered at: ${delivered_at}`}>
                 <InfoCircleOutlined style={{ marginLeft: 8, color: "#000" }} />
               </Tooltip>
             )}
           </>
           ),
         };
       },
     },
     {
       title: "Item Code",
       dataIndex: "item_id",
       key: "item_id",
      //  width: 80,
     },
     {
       title: "Item Name",
       dataIndex: "item_name",
       key: "item_name",
      //  width: 250,
     },
     
     
     
     {
       title: "Ordered QTY",
       dataIndex: "quantity",
       key: "quantity",
      //  width: 80,
       align: 'center'
     },
     {
       title: "Delivered QTY",
       dataIndex: "delivered_quantity",
       key: "delivered_quantity",
      //  width: 80,
       align: 'center'
 
     },
     {
       title: "Returned QTY",
       render: (text, record) => {
         return (
           <span>
             
               <>{Number(record?.quantity) - Number(record?.delivered_quantity)}</>
           </span>
         );
       },
      //  width: 80,
       align: 'center'
 
     },
     {
       title: "Warehouse Received QTY (Quarantine)",
       dataIndex: "returned_quantity",
       key: "returned_quantity",
      //  width: 80,
       align: 'center'
 
     },
     {
       title: "Returned To Stock QTY",
       dataIndex: "returned_quantity_to_stock",
       key: "returned_quantity_to_stock",
      //  width: 80,
       align: 'center'
 
     },
     {
           title: "Damages",
           render: (text, record) => {
             const value = record?.returned_quantity_to_damages || 0; 
             return (
               <span>
                 {value > 0 ? (
                   <Tag color="red">{value}</Tag>
                 ) : (
                   <span>{value}</span> 
                 )}
               </span>
             );
           },
          //  width: 100,
           align: "center",
         },
     
     {
       title: "Customer Delivery Status",
       render: (record) => {
               const status = deliveryStatuses.find(item => item.id === record?.delivery_status)
               return (
                  <span>{status ? status.title : ''}</span>
               );
             },
      //  width: 120,
       align: 'center'
 
     },
     {
       title: "Warehouse Delivery Status",
       render: (record) => {
               const status = StockChangeReasons.find(item => item.id === record?.returned_quantity_to_stock_status)
               return (
                  <span>{status ? status.title : ''}</span>
               );
             },
      //  width: 120,
       align: 'center'
 
     },
     {
       title: "Customer Support Status",
       render: (record) => {
               const status = returnStatuses.find(item => item.id === record?.return_status)
               return (
                  <span>{status ? status.title : ''}</span>
               );
             },
      //  width: 120,
       align: 'center'
 
     },
    //  {
    //     title: "Updated At",
    //     dataIndex: "return_status_updated_at", 
    //     align: "center",
    //     render: (value) => {
    //       if (!value) return "-";
    //       return dayjs(value).isValid()
    //         ? dayjs(value).format("DD-MM-YYYY HH:mm:ss") 
    //         : "";
    //     },
    //   },
    {
  title: "Updated By",
  align: "center",
  render: (record) => {
    const updatedBy = record?.return_status_updated_by
      ? record.return_status_updated_by
      : "";

    const updatedAt =
      record?.return_status_updated_at &&
      dayjs(record.return_status_updated_at).isValid()
        ? dayjs(record.return_status_updated_at).format("DD-MM-YYYY HH:mm:ss")
        : null;

    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span>{updatedBy}</span>
        {updatedAt && (
          <Tooltip title={`Updated at: ${updatedAt}`}>
            <InfoCircleOutlined style={{ marginLeft: 6, color: "#1890ff" }} />
          </Tooltip>
        )}
      </div>
    );
  },
},
  //    {
  //   title: "Action",
  //   align: "center",
  //   render: (record) => {
  //     const items = returnStatuses.flatMap((option, idx) => {
  //       const menuItem = {
  //         key: option.id,
  //         label: option.title,
  //         onClick: () => handleUpdateStatus(record, option),
  //       };
  //       return idx < returnStatuses.length - 1
  //         ? [menuItem, { type: "divider" }]
  //         : [menuItem];
  //     });

  //     return (
  //       <Dropdown trigger={["click"]} menu={{ items }}>
  //         <ExportOutlined
  //           className="animated-select-icon"
  //           style={{ fontSize: 22, cursor: "pointer" }}
  //         />
  //       </Dropdown>
  //     );
  //   },
  // },
   {
    title: "Action",
    align: "center",
    render: (record) => {
      return (
          <ExportOutlined
            className="animated-select-icon"
            style={{ fontSize: 22, cursor: "pointer" }}
            onClick={()=> {
              setSelectedItem(record)
              setModalOpen(true)
              setReturnUpdate({
                status: record?.return_status || null,
                department: record?.return_department || null,
                reason: record?.return_reason || null,
                notes: record?.return_notes || ''
              })
            }}
          />
      );
    },
  },
   ];

   const handleUpdateStatus = async () => {
    if (!returnUpdate?.status) return showMessage('error', 'Please select return status')
    if (!returnUpdate?.department) return showMessage('error', 'Please select department')
    if (!returnUpdate?.reason) return showMessage('error', 'Please select reason')
    showLoading(layoutDispatch)
    try {
    const res = await Auth.fetch("/report/return-status", {
      method: "PUT",
      body: JSON.stringify({
        item_pallet_id: selectedItem?.item_pallet_id, 
        return_status: returnUpdate?.status,
        return_department: returnUpdate?.department,
        return_reason: returnUpdate?.reason,
        return_notes: returnUpdate?.notes
      }),
    });
    if(res?.ack) {
      showMessage('success', res?.message || 'Status updated successfully')
      setSelectedItem(null)
      setReturnUpdate({
      status: null,
      department: null,
      reason: null,
      notes: ''
    })
      setModalOpen(false)
      getAllReturns()
    } else {
      showMessage('error', res?.message );
      hideLoading(layoutDispatch)
    }

  } catch (err) {
    console.error("API Error:", err);
    showMessage('error', 'something went wroing')
  }
};
 
   const downloadCSV = () => {
     // Prepare data for CSV
     const csvData = returns?.map((record) => ({
       Route: record.title || "",
       Driver: record.driver_name || "",
       Vehicle: record.registration_number || "",
       Customer: record.customer_name || "",
       Invoice: record.invoice_no || "",
       Order: record.sale_order_no || "",
       "Delivery Status": (() => {
         switch (record.delivered) {
           case 1:
             return "Delivered";
           case 2:
             return "Postponed";
           case -1:
             return "Submitted";
           default:
             return "Not Delivered";
         }
       })(),
       // "Delivered At":
       //   record.delivered_at && moment(record.delivered_at).isValid()
       //     ? moment(record.delivered_at).format("YYYY-MM-DD HH:mm:ss")
       //     : "N/A",
       "Item Code": record.item_id || "",
       "Item Name": record.item_name || "",
       "Ordered QTY": record.quantity || 0,
       "Delivered QTY": record.delivered_quantity || 0,
       "Returned QTY": record.quantity - record.delivered_quantity || 0,
       "Warehouse Received QTY (Quarantine)": record.returned_quantity || 0,
       "Returned To Stock QTY": record.returned_quantity_to_stock || 0,
       Damages: record.returned_quantity_to_damages || 0,
       "Customer Delivery Status": deliveryStatuses.find((item) => item.id === record.delivery_status)?.title || "",
       "Warehouse Delivery Status": StockChangeReasons.find((item) => item.id === record.returned_quantity_to_stock_status)?.title || "",
     }));
 
 
   const csvString =
       "data:text/csv;charset=utf-8," +
       [
         Object.keys(csvData[0]).join(","), // Header row
         ...csvData.map((row) => Object.values(row).join(",")), // Data rows
       ].join("\n");
 
     // Create a link and trigger download
     const link = document.createElement("a");
     link.href = encodeURI(csvString);
     link.download = `allreturns${dayjs().format(DATE_FORMAT)}.csv`;
     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
   };

   const cancelModal = () => {
    setModalOpen(false)
    setSelectedItem(null)
    setReturnUpdate({
      status: null,
      department: null,
      reason: null,
      notes: ''
    })
   }

   useEffect(() => {
       message.config({
         top: window.innerHeight - 100, 
         duration: 3, 
       });
     }, [])

     

  return (
     <div className={classes.dataSheet}>
            <div style={{ marginBottom: "10px",display: "flex", justifyContent: "space-between" }}>
            <h3 style={{ margin: 0}}>All Returns</h3>
            {returns?.length > 0 && (
              <div >
                <Button type="primary" 
                // onClick={downloadCSV}
                onClick={() => { getAllReturns(1) }}

                >
                  Download
                </Button>
              </div>
            )}
            </div>
            
            <div className="view-page">
            <Grid container rowSpacing={2} columnSpacing={1.5}>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
              <label htmlFor="pcnDate">Start Date:</label>
              <DatePicker
                   format={DATE_FORMAT}
                   style={{ width: '100%'}}
                   size="large"
                   value={startDate ? dayjs(startDate) : null}
                  //  onChange={(_, dateStr) => {
                  //   setStartDate(dateStr);
                  //   setPageChange(false)
                  //   setPage(1)
                  // }}
                  onChange={(date) => {
                    const dateStr = date ? date.format(DEFAULT_DATE_FORMAT) : null;
                    if (endDate && dayjs(dateStr).add(31, 'days').isBefore(dayjs(endDate))) {
                      message.error("The date range cannot exceed 31 days.");
                      return;
                    }
                    setStartDate(dateStr);
                    setPageChange(false);
                    setPage(1);
                  }}
                  placeholder="Select Start Date" 
                  
                    />

            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
              <label htmlFor="pcnDate">End Date:</label>
              <DatePicker
                   format={DATE_FORMAT}
                   style={{ width: '100%'}}
                   size="large"
                   value={endDate ? dayjs(endDate) : null}
                  //  onChange={(_, dateStr) => {
                  //   setEndDate(dateStr);
                  //   setPageChange(false)
                  //   setPage(1)
                  // }}
                   onChange={(date) => {
                    const dateStr = date ? date.format(DEFAULT_DATE_FORMAT) : null;
                    if (startDate && dayjs(dateStr).subtract(31, 'days').isAfter(dayjs(startDate))) {
                      message.error("The date range cannot exceed 31 days.");
                      return;
                    }
                    setEndDate(dateStr);
                    setPageChange(false);
                    setPage(1);
                  }}
                  placeholder="Select Date" 
                   />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
          <label htmlFor="endDate">Order Status</label>
          <Select
              style={{
                width: "100%",
              }}
              showSearch
              size="large"
              value={orderStatus}
              placeholder="Order Status"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              onChange={(value) => {
                setOrderStatus(value)
                setPageChange(false)
                setPage(1)

              }}
            >
              {orderStats.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item?.title}
                </Option>
              ))}
            </Select>
        </Grid> */}
        <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
          <label htmlFor="endDate">Order Status</label>
          <Select
              style={{
                width: "100%",
              }}
              showSearch
              size="large"
              value={selectedOrderStatus}
              placeholder="Order Status"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              onChange={(value) => {
                setSelectedOrderStatus(value)
                setPageChange(false)
                setPage(1)

              }}
            >
              {orderStats.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item?.title}
                </Option>
              ))}
            </Select>
        </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
          <label htmlFor="endDate">Delivery Status</label>
          <Select
              style={{
                width: "100%",
              }}
              showSearch
              size="large"
              value={selectedStatus}
              placeholder="Delivery Status"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              onChange={(value) => {
                setSelectedStatus(value)
                setPageChange(false)
                setPage(1)

              }}
            >
              {deliveryStatuses.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item?.title}
                </Option>
              ))}
            </Select>
        </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
          <label htmlFor="endDate">Search</label>
          <Input
            id="searchText"
            name="searchText"
            value={searchInput?.searchText}
            onChange={(e) => {
              setSearchInput((prevDetails) => ({
                ...prevDetails,
                searchText: e.target.value,
              }))
            }}
            size="large"
            placeholder="Customer, Order, Invoice"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={2} xl={1.5}>
          <Button  style={{ marginTop: '20px'}} onClick={() => { getAllReturns(false) }} type="primary" size='large'>Search </Button>
        </Grid>
          </Grid>
              <Table
                style={{ marginTop: "10px" }}
                scroll={{ x: 'max-content'}}
                columns={detailsCol}
                dataSource={returns}
                pagination={false}
                footer={() => {
                    const startRecord = (page - 1) * limit + 1;
                    const endRecord = Math.min(page * limit, returns?.length ? totalCount : 0); 
                    return `Showing ${startRecord}-${endRecord} of ${returns?.length ? totalCount : "0"} Records`;
                  }}
                rowClassName={(row, index) => row?.return_status_updated_by  ? "" : 'highlight-row'}
              />
              <div style={{ float: "right", margin: "10px" }}>
                      <Pagination
                        page={page}
                        count={totalPages}
                        variant="outlined"
                        color="primary"
                        onChange={handleChange}

                      />
                    </div>
            </div>

            <Modal open={modalOpen} title="Update Return Status" onCancel={cancelModal} onOk={handleUpdateStatus} okText="Update" width={'70vw'}> 
              <Divider  style={{ margin: '2px 2px'}}/>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={12} lg={8} xl={8}>
                  <label htmlFor="status">Return Status</label>
                  <Select
                      style={{
                        width: "100%",
                      }}
                      showSearch
                      size="large"
                      value={returnUpdate?.status}
                      placeholder="Status"
                      filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                      }
                      onChange={(value) => {
                        setReturnUpdate((prev) => ({
                          ...prev,
                          status: value
                        }))
                      }}
                    >
                    {returnStatuses.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item?.title}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8} xl={8}>
                  <label htmlFor="status">Department</label>
                  <Select
                      style={{
                        width: "100%",
                      }}
                      showSearch
                      size="large"
                      value={returnUpdate?.department}
                      placeholder="Department"
                      filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                      }
                      onChange={(value) => {
                        setReturnUpdate((prev) => ({
                          ...prev,
                          department: value
                        }))
                      }}
                    >
                    {departments.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item?.title}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8} xl={8}>
                  <label htmlFor="status">Reason</label>
                  <Select
                      style={{
                        width: "100%",
                      }}
                      showSearch
                      size="large"
                      value={returnUpdate?.reason}
                      placeholder="Reason"
                      filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                      }
                      onChange={(value) => {
                        setReturnUpdate((prev) => ({
                          ...prev,
                          reason: value
                        }))
                      }}
                    >
                    {deliveryStatuses.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item?.title}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>
              <Row gutter={[16,16]} style={{ marginTop: 10}}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <TextArea 
                autoSize={{ minRows: 3, maxRows: 5 }}
                placeholder="Notes"
                value={returnUpdate?.notes}
                onChange={(e) => {
                  setReturnUpdate((prev) => ({
                    ...prev,
                    notes: e.target.value
                  }))
                }}
                />
                </Col>
              </Row>
            </Modal>
          
          <Message type={type} msg={loadMessage} />
        </div>
  )
}

export default AllReturnsNew
